import { Link } from "@tanstack/react-router";

import { Button } from "./ui/button";

export const NotFound = () => {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="space-y-2">
          <h1 className="text-9xl font-bold tracking-tight">404</h1>
          <h2 className="h2 text-balance">Page not found</h2>
          <p className="text-muted-foreground text-pretty">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button asChild>
            <Link to="/">Go home</Link>
          </Button>
          <Button onClick={() => window.history.back()} variant="outline">
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
};
